import { createAsyncThunk } from '@reduxjs/toolkit'

import callAPI from 'api'
import { Success, Fail } from 'store/types'
import { LeadAddressResponse, LeadDetailResponse, GetLeadTabCountResponse } from './types/lead'

import { GetLeadContactsResponse } from './types/lead-contact'

type Response = {
  lead_detail: LeadDetailResponse
  lead_contacts: GetLeadContactsResponse[]
  lead_addresses: LeadAddressResponse
  lead_tab_count: GetLeadTabCountResponse
}

type Payload = { lead_id: string }

export const getDetailApi = async (payload: Payload) =>
  callAPI<Response, Payload>('crm_get_lead_complete_details', [payload], {
    requireAuthorization: true,
  })

export const getDetail = createAsyncThunk<Fail | Success<Response>, Payload>('lead/detail', getDetailApi)
